(function () {
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  var SELECTOR = 'main .title, main .grid__item, .trust-bar__item, .ctabs__nav, .collection__view-all, .rich-text__blocks, .nv-tm, .nv-ed, .nv-bs__item, .nv-eyebrow';
  var pending = [];

  function num(re, s) { var m = s.match(re); return m ? m[1] : null; }
  function formatSizes(scope) {
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('.product-form__input input[type=radio] + label').forEach(function (label) {
      if (label.dataset.nvSize) return;
      var raw = label.textContent.replace(/\s+/g, ' ').trim();
      var col = num(/(\d+(?:[.,]\d+)?)\s*COL/i, raw);
      if (!col) return;
      var eur = num(/(\d+(?:[.,]\d+)?)\s*EUR/i, raw);
      var us = num(/(\d+(?:[.,]\d+)?)\s*US/i, raw);
      var cm = num(/(\d+(?:[.,]\d+)?)\s*CM/i, raw);
      var g = num(/\((WM|MEN|D|W|C|M|H)\)/i, raw);
      var gender = g ? (/^(WM|D|W)$/i.test(g) ? 'Mujer' : 'Hombre') : '';
      var sub = [eur && 'EU ' + eur, us && 'US ' + us, cm && cm + ' cm'].filter(Boolean).join(' · ');
      label.dataset.nvSize = '1';
      label.setAttribute('title', raw.replace(/,\s*$/, ''));
      label.innerHTML = '<span class="nv-size__main"><span class="nv-size__col">' + col + ' COL</span>' + (gender ? '<span class="nv-size__g">' + gender + '</span>' : '') + '</span>' + (sub ? '<span class="nv-size__sub">' + sub + '</span>' : '');
      label.classList.add('nv-size');
    });
  }
  formatSizes(document);

  var btt = document.createElement('button');
  btt.type = 'button';
  btt.className = 'nv-top';
  btt.setAttribute('aria-label', 'Volver arriba');
  btt.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
  btt.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' }); });
  document.body.appendChild(btt);

  function collect(scope) {
    if (rm || !scope.querySelectorAll) return;
    scope.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('nv-reveal') || el.closest('quick-add-modal')) return;
      var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--nv-d', Math.min(idx, 7) * 70 + 'ms');
      el.classList.add('nv-reveal');
      pending.push(el);
    });
  }

  function check() {
    var y = window.scrollY;
    root.classList.toggle('nv-scrolled', y > 40);
    btt.classList.toggle('is-visible', y > 900);
    if (!pending.length) return;
    var limit = window.innerHeight * 0.94;
    pending = pending.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return true;
      if (r.top < limit) { el.classList.add('is-in'); return false; }
      return true;
    });
  }

  var last = 0, timer = null;
  function onScroll() {
    var now = Date.now();
    if (now - last > 80) { last = now; check(); }
    clearTimeout(timer);
    timer = setTimeout(check, 100);
  }

  if (!rm) root.classList.add('nv-motion');
  collect(document);
  check();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('click', function () { setTimeout(check, 60); });
  setInterval(function () { if (pending.length) check(); }, 600);

  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      var added = false;
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { collect(n); formatSizes(n); added = true; } }); });
      if (added) setTimeout(check, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
